<template>

    <svg viewBox="0 0 100 100" >


        <rect x="30" y="30" width="40" height="40" fill="red" ></rect>

        <circle cx="50" cy="50" r="47"
                class="class_circle"
                :stroke-dasharray="maxDasharray_n +'px'"
                :stroke-dashoffset="m_getCircleDasharray_s"
                stroke-linecap="round"
                stroke="white"
                stroke-width="2"
                fill="none">
        </circle>

        <!--<text x="62" y="60" class="TQ_text_24px" text-length="30px" >{{p_timePassed_n}}</text>-->

    </svg>


</template>

<script>
    export default {
        name: "si_CameraButton",
        props:{
            p_maxTime_n:{
                type: Number,
                default: 60
            },
            p_timePassed_n:{
                type: Number,
                default: 40
            }
        },
        data(){
            return {
                maxDasharray_n : 300

            }
        },
        computed:{
            m_getCircleDasharray_s(){
                return (this.maxDasharray_n * this.p_timePassed_n / this.p_maxTime_n) + "px"
            }
        }

    }
</script>

<style scoped lang="scss">

    .class_circle{
        transform: rotate(-90deg);
        transform-origin: center;
        animation: null 0.1s linear infinite forwards;
    }

</style>